$(document).ready(function () {
  $(".btn:not(.no-icon)").append("<div class='effect'></div>");
  function scrollToTop() {
    var $scrollUp = $("#scroll-top"),
      $lastScrollTop = 0,
      $window = $(window);

    $window.on("scroll", function () {
      var st = $(this).scrollTop();
      if (st > $lastScrollTop) {
        $scrollUp.removeClass("show");
      } else {
        if ($window.scrollTop() > 200) {
          $scrollUp.addClass("show");
        } else {
          $scrollUp.removeClass("show");
        }
      }
      $lastScrollTop = st;
    });

    $scrollUp.on("click", function (evt) {
      $("html, body").animate({ scrollTop: 0 }, 600);
      evt.preventDefault();
    });
  }
  scrollToTop();
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    if (scroll >= 250) {
      $("body").addClass("is-sticked");
      $(".wrapper").css("padding-top", $(".header").outerHeight() + "px");
    } else {
      $("body").removeClass("is-sticked");
      $(".wrapper").css("padding-top", "0px");
    }
  });
  $(".header-nav-toggle-btn, .nav-overlay").click(function () {
    $("body").toggleClass("nav-open");
  });
  $(".header-nav li:has(ul)").prepend('<span class="arrow"></span>');
  $(".arrow").click(function () {
    $(this).siblings("ul").slideToggle("slow");
    $(this).toggleClass("active");
  });
  new WOW().init();
  $(".hero-product-slider").slick({
    dots: true,
    appendDots: $(".hero-product-slider-dots"),
    arrows: false,
    infinite: true,
    fade: true,
    autoplay: false,
    autoplaySpeed: 2000,
    speed: 1200,
  });
  $(".testimonials-slider:not(.count-1)").slick({
    dots: false,
    arrow: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  $(".testimonials-slider.count-1").slick({
    dots: false,
    arrow: true,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          dots: true,
        },
      },
    ],
  });
  $(".product-details-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: false,
    asNavFor: ".product-details-slider-nav",
  });
  $(".product-details-slider-nav").slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    asNavFor: ".product-details-slider",
    dots: false,
    arrows: false,
    focusOnSelect: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
    ],
  });

   $(document).on("click",".btn-qty",function(e) { 

      var value = $(this).closest('.quantity-input-wrap').find('.qty-input').val();
      var seleType = $(this).attr('data-type');
      if(seleType == 'minus'){
     // alert(value);
     
        //console.log(value++);
          value++;
      }else if(seleType == 'plus'){
         value = isNaN(value) ? 0 : value;
        if(value>1){
          value--;
        }
      }
      $(this).closest('.quantity-input-wrap').find('.qty-input').val(value);
  });  


$(".testimonials-grid").masonry({
    columnWidth: ".grid-sizer",
    gutter: ".gutter-sizer",
    itemSelector: ".grid-item",
    percentPosition: true,
    horizontalOrder: true,
  });
});
